import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { AuthProvider } from './contexts/AuthContext.tsx'
import { restoreYandexFlowParams } from './utils/yandex.ts'
import { initSkin } from './utils/skin.ts'

// Скин — раньше восстановления параметров Яндекса: в вернувшемся адресе снова будут return_url/service
// без skin, и initSkin принял бы это за свежий вход другого сервиса.
initSkin()

// Возврат из Яндекса приходит на голый redirect_uri: параметры страницы
// (return_url/mode/service) возвращаем в адрес ДО рендера — их читает весь код ниже.
restoreYandexFlowParams()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>,
)
